// extracted by mini-css-extract-plugin
export default {"dropdownBreadcrumb":"styles_dropdownBreadcrumb__XOvUB"};